import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useFunnel } from '../../contexts/FunnelContext'
import { ProgressBar } from '../../components/funnel/ProgressBar'
import { PrimaryButton } from '../../components/funnel/PrimaryButton'
import { LoadingSpinner } from '../../components/funnel/LoadingSpinner'
import { Shield, Calendar } from 'lucide-react'

const challengeLabels: Record<string, string> = {
  'high-energy-bills': 'high energy bills',
  'unexpected-repairs': 'unexpected repairs',
  'drafty-windows': 'drafty windows or doors',
  'plumbing-leaks': 'plumbing or leak worries',
  'maintenance-upkeep': 'keeping up with maintenance',
  'trusted-contractors': 'finding trusted contractors',
}

const Step3Page: React.FC = () => {
  const navigate = useNavigate()
  const { state } = useFunnel()
  const [isLoading, setIsLoading] = useState(false)

  const topConcern =
    state.challenges.length > 0
      ? challengeLabels[state.challenges[0]] || 'home maintenance'
      : 'home maintenance'

  return (
    <div style={{ backgroundColor: 'rgb(246, 246, 241)', minHeight: '100vh', padding: '2rem 0' }}>
      <div className="mx-auto max-w-2xl px-8">
        <ProgressBar currentStep={3} totalSteps={4} />

        <h2 className="text-3xl font-semibold mb-6" style={{ color: 'rgb(15,15,15)' }}>
          Proactive Care is the Key to a Worry-Free Winter
        </h2>

        <p className="text-lg mb-8" style={{ color: 'rgb(76,76,75)' }}>
          You mentioned you're concerned about <strong>{topConcern}</strong>. Our Home Refresh
          service is designed to address exactly that by catching small issues before they become
          costly surprises.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mb-8">
          <div className="bg-white p-6 rounded-xl">
            <Shield className="w-12 h-12 mb-4" style={{ color: '#145F6B' }} />
            <h3 className="text-xl font-semibold mb-3" style={{ color: 'rgb(15,15,15)' }}>
              Protect Your Investment
            </h3>
            <p className="text-base" style={{ color: 'rgb(76,76,75)' }}>
              Our comprehensive check-up identifies hidden risks in your HVAC, plumbing, and
              electrical systems, saving you thousands in potential repairs.
            </p>
          </div>

          <div className="bg-white p-6 rounded-xl">
            <Calendar className="w-12 h-12 mb-4" style={{ color: '#145F6B' }} />
            <h3 className="text-xl font-semibold mb-3" style={{ color: 'rgb(15,15,15)' }}>
              Save Time & Hassle
            </h3>
            <p className="text-base" style={{ color: 'rgb(76,76,75)' }}>
              We handle the essential maintenance tasks you don't have time for, all in a single,
              efficient visit.
            </p>
          </div>
        </div>

        <PrimaryButton
          onClick={async () => {
            setIsLoading(true)
            await new Promise((resolve) => setTimeout(resolve, 500))
            navigate('/winter-refresh/step-4')
          }}
          disabled={isLoading}
          fullWidth
        >
          {isLoading ? (
            <div className="flex items-center justify-center gap-2">
              <LoadingSpinner size="sm" />
              <span>Loading Packages...</span>
            </div>
          ) : (
            'See the Packages'
          )}
        </PrimaryButton>
      </div>
    </div>
  )
}

export default Step3Page

